import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import "leaflet-routing-machine";
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
declare let google: any;
declare let L;

@Component({
  selector: 'app-trip-edit-zone',
  templateUrl: './trip-edit-zone.component.html',
  styleUrls: ['./trip-edit-zone.component.scss']
})
export class TripEditZoneComponent implements OnInit {
  currentZone;
  mapCenter: any;
  map: any = {};
  zonebounds: any = [];
  zonePoly: any[] = [];
  zones: any[] = [];
  marker: any;
  searchZone: any;
  editzonebounds: any = [];
  editZoneFlag = false;
  polydata;
  isOsm: boolean = false;
  _layer: any;
  toggleEditZone: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private readonly apiService: ApiService,
    private serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService
  ) { }

  ngOnInit() {
    this.resolveMapTypeAndInit();
    // setTimeout(() => {
    //   if (AppConstants.OSRM === this.serviceLocalStorage.getMapType()) {
    //     this.isOsm = true;
    //   }
    //   this.getTripZones();
    // }, 10);
  }

  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.isOsm = !this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    if (this.isOsm) {
      setTimeout(() => this.getTripZones(), 10);
      return;
    }
    this.ensureGoogleMapsReady().then(() => this.getTripZones());
  }

  private async ensureGoogleMapsReady(): Promise<void> {
    if (typeof google !== 'undefined' && google.maps?.Map) {
      return;
    }
    if (typeof google !== 'undefined' && google.maps?.importLibrary) {
      await google.maps.importLibrary('maps');
    }
  }

  getTripZones() {
    const tripId = this.route.snapshot.params.tripId;
    if (tripId != null) {
      this.apiService.doGetRequestWithResponse(ApiConstants.getZoneByTripId + tripId, success => {
        const data = success.body;
        data.isEdit = false;
        this.currentZone = data;
        this.getZoneList(success.body);
        this.plotZone(success.body, false);
        this.getTripUsers(tripId);
      }, error => {
        console.log(error)
      }
      );
    }
  }

  drawMap(trip) {
    this.zonePoly = [];
    this.polydata = null;
    this._layer = null;
    if (!this.isOsm) {
      this.mapCenter = {
        lat: parseFloat(trip[0].lat),
        lng: parseFloat(trip[0].lng)
      };
      this.map = new google.maps.Map(document.getElementById("zonemap"), {
        center: this.mapCenter,
        zoom: 13,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      return;
    }
    // if (Object.entries(this.map).length !== 0) {
    //   this.map.remove();
    // }
    // this.map = L.map("zonemap", {
    //   fullscreenControl: true
    // }).setView([parseFloat(trip[0].lat), parseFloat(trip[0].lng)], 13);
    // L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
    // this.map.addControl(new L.Control.Search(AppConstants.OSM_NOMINATIM_Obj));
    const start = (trip || []).find(point => Number.isFinite(Number(point?.lat)) && Number.isFinite(Number(point?.lng)));
    if (!start) {
      this.notifyService.showError("Zone boundary is invalid.", null);
      return;
    }
    this.resetOsmMap();
    this.map = L.map("zonemap", {
      fullscreenControl: true
    }).setView([Number(start.lat), Number(start.lng)], 13);
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
    this.map.addControl(new L.Control.Search(AppConstants.OSM_NOMINATIM_Obj));
  }

  private resetOsmMap(): void {
    if (this.map && typeof this.map.remove === 'function') {
      this.map.off();
      this.map.remove();
    }
    this.map = {};
    const el = document.getElementById('zonemap') as any;
    if (el) {
      el._leaflet_id = null;
      el.innerHTML = '';
    }
  }

  plotZone(trip, fromZoneList) {
    // let polygonArray = [];
    // let polygonData;
    // polygonData = trip.zonepoly.replace("(", "");
    // polygonData = polygonData.split("),(").join("|");
    // polygonData = polygonData.replace(")", "");
    // polygonData.split("|").forEach(poly => {
    //   polygonArray.push({
    //     lat: parseFloat(poly.split(",")[0]),
    //     lng: parseFloat(poly.split(",")[1])
    //   });
    // });
    // fromZoneList ? "" : this.drawMap(polygonArray);
    const polygonArray = this.parseZonePoly(trip?.zonepoly);
    if (!polygonArray.length) {
      this.notifyService.showError("Zone boundary is invalid.", null);
      return;
    }
    if (!fromZoneList) {
      this.drawMap(polygonArray);
    }
    if (!this.map || (this.isOsm && typeof this.map.addLayer !== 'function')) {
      return;
    }
    if (!this.isOsm) {
      let editableFlag = false;
      this.polydata = new google.maps.Polygon({
        paths: polygonArray,
        editable: editableFlag,
        map: this.map,
        strokeWeight: 3,
        strokeOpacity: 0.8,
        fillOpacity: 0.2,
        fillColor: "#fffccc"
      });
      this.polydata._backEndData = { fromZone: fromZoneList, data: trip };
      this.polydata.addListener("rightclick", event => {
        let infoWindow = new google.maps.InfoWindow();
        infoWindow.setContent(trip.name);
        infoWindow.setPosition(event.latLng);
        infoWindow.open(this.map);
      });
      this.zonePoly.push(this.polydata);
      // this.zonebounds = this.polydata.getPath().getArray();
      // google.maps.event.addListener(this.polydata.getPath(), "set_at", () => {
      //   this.zonebounds = this.polydata.getPath().getArray();
      //   if (this.editZoneFlag)
      //     this.editzonebounds = this.polydata.getPath().getArray();
      // });
      // google.maps.event.addListener(
      //   this.polydata.getPath(),
      //   "insert_at",
      //   () => {
      //     this.zonebounds = this.polydata.getPath().getArray();
      //     if (this.editZoneFlag)
      //       this.editzonebounds = this.polydata.getPath().getArray();
      //   }
      // );
      // google.maps.event.addListener(
      //   this.polydata.getPath(),
      //   "remove_at",
      //   () => {
      //     this.zonebounds = this.polydata.getPath().getArray();
      //     if (this.editZoneFlag)
      //       this.editzonebounds = this.polydata.getPath().getArray();
      //   }
      // );
      this.bindGooglePolygonPath(this.polydata);
    } else {
      this.plotOSZone(polygonArray, trip, fromZoneList);
    }
  }

  plotOSZone(polygonArray, trip, fromZoneList) {
    this.removeEditControlOSM();
    const editableLayers = new L.FeatureGroup();
    this.map.addLayer(editableLayers);
    this.polydata = new L.Control.Draw({
      position: "topleft",
      draw: {
        polygon: false,
        polyline: false,
        circle: false,
        rectangle: false,
        marker: false
      },
      edit: {
        featureGroup: editableLayers,
        remove: false
      }
    });
    // this.polydata._backEndData = {
    //   fromZone: fromZoneList,
    //   data: trip,
    //   leafletId: editableLayers._leaflet_id
    // };
    // editableLayers.addLayer(L.polygon(polygonArray));
    // this.zonePoly.push(this.polydata);
    // this.map.on("draw:created", e => {
    //   this.editZoneFlag = true;
    //   this._layer = e.layer;
    //   editableLayers.addLayer(this._layer);
    //   this.editzonebounds = this._layer._latlngs[0];
    // });
    // this.map.on("draw:edited", e => {
    //   this.editZoneFlag = true;
    //   var layers = e.layers;
    //   layers.eachLayer(layer => {
    //     this._layer = layer;
    //   });
    //   editableLayers.addLayer(this._layer);
    //   this.editzonebounds = this._layer._latlngs[0];
    // });
    const osmPolygon = L.polygon(polygonArray.map(point => L.latLng(point.lat, point.lng)));
    editableLayers.addLayer(osmPolygon);
    this.polydata._backEndData = {
      fromZone: fromZoneList,
      data: trip,
      leafletId: editableLayers._leaflet_id,
      osmLayer: osmPolygon
    };
    this.zonePoly.push(this.polydata);
    this._layer = osmPolygon;
    this.map.off("draw:created");
    this.map.off("draw:edited");
    this.map.on("draw:created", e => {
      this.editZoneFlag = true;
      this._layer = e.layer;
      editableLayers.addLayer(this._layer);
      this.editzonebounds = this.flattenOsmLatLngs(this._layer);
    });
    this.map.on("draw:edited", e => {
      this.editZoneFlag = true;
      e.layers.eachLayer(layer => {
        this._layer = layer;
      });
      this.editzonebounds = this.flattenOsmLatLngs(this._layer);
    });
  }

  getZoneList(data) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getZonesByMasterZoneId + data.masterZone.id + '&siteId=' + data.masterZone.site.siteId +
      '&locationId=' + data.masterZone.site.location.locationId + '&zoneId=' + data.id, success => {
        this.zones = success.body;
      }, error => {
        console.log(error)
      });
  }

  getTripUsers(tripId) {
    const tripIds = [tripId];
    this.apiService.doPostRequestWithResponse(ApiConstants.gettripsbytripids + tripIds, '', success => {
      this.setRoute(success.body[0][0], tripId);
    }, error => {
      console.log(error)
    });
  }

  setRoute(users, tripId) {
    let location;
    let waypoints: any = [];
    let origin: any;
    let destination: any;
    origin = {
      lat: users.tripDetails.site.landmark.latitude,
      lng: users.tripDetails.site.landmark.longitude
    };
    destination = {
      lat: users.tripDetails.site.landmark.latitude,
      lng: users.tripDetails.site.landmark.longitude
    };
    users.tripDetails.tripUsers.forEach((user, u) => {
      location = {
        lat: user.landmark.latitude,
        lng: user.landmark.longitude
      };
      waypoints.push({ location: location, stopover: true });
      this.isOsm ? "" : this.plotEmployees(user, u + 1);
    });
    this.markSite(users.tripDetails.site);
    const isInTrip = users.tripDetails.shift.logType == "IN";
    if (isInTrip) {
      origin = {
        lat: users.tripDetails.tripUsers[0].landmark.latitude,
        lng: users.tripDetails.tripUsers[0].landmark.longitude
      };
    }
    if (users.tripDetails.shift.logType == "OUT") {
      destination = {
        lat:
          users.tripDetails.tripUsers[users.tripDetails.tripUsers.length - 1]
            .landmark.latitude,
        lng:
          users.tripDetails.tripUsers[users.tripDetails.tripUsers.length - 1]
            .landmark.longitude
      };
    }
    // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
    const middleWaypts = (isInTrip ? waypoints.slice(1) : waypoints.slice(0, -1)).map(wp => ({
      lat: wp.location.lat,
      lng: wp.location.lng
    }));
    if (!this.isOsm) {
      this.drawShortestGoogleRoute(origin, destination, middleWaypts);
    } else {
      this.generateRoute(users.tripDetails, tripId);
    }
  }

  /** Shortest driving path — same strategy as BE Routes API computeRoutes. */
  private async drawShortestGoogleRoute(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[] = []
  ): Promise<void> {
    try {
      const drawn = await this.drawShortestRouteViaMapsJs(origin, destination, middlePoints)
        || await this.drawShortestRouteViaRestApi(origin, destination, middlePoints);
      if (drawn) {
        return;
      }
    } catch (error) {
      console.warn('Shortest Routes API path failed; falling back to Directions alternatives', error);
    }
    this.drawShortestRouteViaDirectionsService(origin, destination, middlePoints);
  }

  private async drawShortestRouteViaMapsJs(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    if (!google.maps?.importLibrary) {
      return false;
    }
    const routesLib = await google.maps.importLibrary('routes') as any;
    const RouteClass = routesLib?.Route;
    if (!RouteClass?.computeRoutes) {
      return false;
    }
    const request: any = {
      origin,
      destination,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      fields: ['path', 'distanceMeters', 'polyline']
    };
    if (middlePoints.length) {
      request.intermediates = middlePoints.map(point => ({ location: point }));
    }
    const { routes } = await RouteClass.computeRoutes(request);
    const shortest = this.pickShortestRouteByDistanceMeters(routes);
    if (!shortest) {
      return false;
    }
    let path = shortest.path;
    if (!path?.length && shortest.polyline?.encodedPolyline) {
      path = this.decodeGoogleEncodedPolyline(shortest.polyline.encodedPolyline);
    }
    if (!path?.length) {
      return false;
    }
    this.renderGoogleRoutePath(path);
    return true;
  }

  private async drawShortestRouteViaRestApi(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    const apiKey = this.getGoogleMapsApiKey();
    if (!apiKey) {
      return false;
    }
    const body: any = {
      origin: { location: { latLng: { latitude: origin.lat, longitude: origin.lng } } },
      destination: { location: { latLng: { latitude: destination.lat, longitude: destination.lng } } },
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      languageCode: 'en-US',
      units: 'METRIC'
    };
    if (middlePoints.length) {
      body.intermediates = middlePoints.map(point => ({
        location: { latLng: { latitude: point.lat, longitude: point.lng } }
      }));
    }
    const response = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'routes.distanceMeters,routes.polyline.encodedPolyline'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      console.warn('Routes REST API failed', response.status, await response.text());
      return false;
    }
    const payload = await response.json();
    const shortest = this.pickShortestRouteByDistanceMeters(payload?.routes);
    const encoded = shortest?.polyline?.encodedPolyline;
    if (!encoded) {
      return false;
    }
    this.renderGoogleRoutePath(this.decodeGoogleEncodedPolyline(encoded));
    return true;
  }

  private drawShortestRouteViaDirectionsService(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): void {
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      draggable: false,
      polylineOptions: { strokeWeight: 3, strokeColor: '#0080FE' },
      suppressMarkers: true
    });
    directionsDisplay.setMap(this.map);
    directionsService.route({
      origin,
      destination,
      waypoints: middlePoints.map(point => ({ location: point, stopover: true })),
      optimizeWaypoints: false,
      travelMode: google.maps.DirectionsTravelMode.DRIVING,
      avoidHighways: false,
      avoidTolls: false,
      provideRouteAlternatives: middlePoints.length === 0
    }, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK && response?.routes?.length) {
        const shortestRoute = response.routes.reduce((shortest, route) => {
          const shortestDist = this.getDirectionsRouteDistanceMeters(shortest);
          const routeDist = this.getDirectionsRouteDistanceMeters(route);
          return routeDist < shortestDist ? route : shortest;
        }, response.routes[0]);
        response.routes = [shortestRoute];
        directionsDisplay.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  private pickShortestRouteByDistanceMeters(routes: any[] | undefined): any | null {
    if (!routes?.length) {
      return null;
    }
    return routes.reduce((shortest, route) => {
      const shortestDist = shortest?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      const routeDist = route?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      return routeDist < shortestDist ? route : shortest;
    }, routes[0]);
  }

  private getDirectionsRouteDistanceMeters(route: any): number {
    return (route?.legs || []).reduce((sum, leg) => sum + (leg?.distance?.value || 0), 0);
  }

  private renderGoogleRoutePath(path: any[]): void {
    if (!path?.length || !this.map) {
      return;
    }
    new google.maps.Polyline({
      path,
      strokeColor: '#0080FE',
      strokeWeight: 3,
      strokeOpacity: 1,
      map: this.map
    });
  }

  private getGoogleMapsApiKey(): string | null {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const mapsScript = scripts.find(script => script.src?.includes('maps.googleapis.com/maps/api/js'));
    if (!mapsScript?.src) {
      return null;
    }
    try {
      return new URL(mapsScript.src).searchParams.get('key');
    } catch {
      return null;
    }
  }

  private decodeGoogleEncodedPolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates: { lat: number; lng: number }[] = [];
    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);

      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return coordinates;
  }

  generateRoute(users, tripId) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getdirectionresult + tripId, success => {
      let wps = [];
      success.body.OSRM.waypoints.forEach((wp, i) => {
        wps.push(L.latLng(wp.location[1], wp.location[0]));
      });
      let r = L.Routing.control({
        serviceUrl: AppConstants.OSM_ROUTING_URL,
        showAlternatives: false,
        lineOptions: {
          styles: [
            {
              color: "#000",
              weight: 3,
              opacity: 0.7
            }
          ]
        },
        fitSelectedRoutes: true,
        waypointMode: "connect",
        addWaypoints: false,
        draggableWaypoints: false,
        autoRoute: true,
        reverseWaypoints: false,
        altLineOptions: {
          styles: [
            {
              color: "#ed6852",
              weight: 3
            }
          ]
        },
        show: true,
        routeWhileDragging: false,
        createMarker: (i, wp, nWps) => {
          if (success.body.LOGTYPE === "IN") {
            if (i === users.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: "./assets/images/company.png",
                  iconSize: [40, 40]
                }),
                title: users.site.landmark.landmark
              });
              return m;
            }
          } else {
            if (i === 0) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: "./assets/images/company.png",
                  iconSize: [40, 40]
                }),
                title: users.site.landmark.landmark
              });
              return m;
            }
          }
          if (success.body.LOGTYPE === "IN") {
            if (i < users.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: users.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                    ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                  iconSize: [65, 70]
                }),
                title: users.tripUsers[i].tripUser.userInfoDetails.displayName
              })
                .bindTooltip(i + 1 + "", {
                  permanent: true,
                  direction: "left",
                  offset: L.point(-10, 0)
                })
                .openTooltip();
              return m;
            }
          } else {
            if (i - 1 <= users.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: users.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                    ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                  iconSize: [65, 70]
                }),
                title:
                  users.tripUsers[i - 1].tripUser.userInfoDetails
                    .displayName
              }).bindTooltip(i + "", {
                permanent: true,
                direction: "left",
                offset: L.point(-10, 0)
              })
                .openTooltip();
              return m;
            }
          }
        }
      }).addTo(this.map);
      r.setWaypoints(wps);
      r.hide();
    }, error => {
      console.log(error)
    });
  }

  markSite(site) {
    if (!this.isOsm) {
      let sitecordinates = new google.maps.LatLng(
        site.landmark.latitude,
        site.landmark.longitude
      );
      let path = "./assets/images/company.png";
      this.marker = new google.maps.Marker({
        position: sitecordinates,
        icon: {
          url: path,
          scaledSize: new google.maps.Size(40, 40)
        },
        map: this.map,
        title: site.siteName
      });
    }
  }

  plotEmployees(tripUser, index) {
    let location = {
      lat: tripUser.landmark.latitude,
      lng: tripUser.landmark.longitude
    };
    let path = "./assets/images/livetracking/maleloc.svg";
    if (tripUser.tripUser.userInfoDetails.gender == "Female") {
      path = "./assets/images/livetracking/femaleloc.svg";
    }
    this.marker = new google.maps.Marker({
      position: location,
      draggable: false,
      title: tripUser.tripUser.userInfoDetails.displayName + " - " + tripUser.landmark.area.area,
      icon: {
        url: path,
        scaledSize: new google.maps.Size(65, 70),
        anchor: new google.maps.Point(32, 70),
        labelOrigin: new google.maps.Point(32, -6)
      },
      animation: google.maps.Animation.DROP,
      map: this.map,
      label: {
        text: "P" + index,
        color: "#000",
        fontWeight: "bold",
        fontSize: "12px"
      }
    });
  }

  zoneListChanged(e, zone) {
    this.zones.forEach((inZone, z) => {
      if (zone.id === inZone.id) {
        this.zones[z].isEditClicked = e.checked;
      }
    });
    if (e.checked) {
      this.plotZone(zone, true);
    } else {
      this.zonePoly.forEach((zones, zIndex) => {
        if (
          zones._backEndData.fromZone &&
          zones._backEndData.data.id === zone.id
        ) {
          if (this.isOsm) {
            this.map.eachLayer(layer => {
              if (
                this.zonePoly[zIndex]._backEndData.leafletId ===
                layer._leaflet_id
              ) {
                this.map.removeLayer(layer);
                this.map.removeControl(zones);
              }
            });
          } else {
            this.zonePoly[zIndex].setMap(null);
          }
        }
      });
    }
  }

  removeEditControlOSM() {
    // if (this.isOsm) {
    //   this.zonePoly.forEach(zone => {
    //     this.map.removeControl(zone);
    //   });
    // }
    if (!this.isOsm || !this.map?.removeControl) {
      return;
    }
    this.zonePoly.forEach(zone => {
      try {
        this.map.removeControl(zone);
      } catch { }
    });
  }

  editZone(zone) {
    this.removeEditControlOSM();
    this.editzonebounds = [];
    // this.editzonebounds.push(zone.zonepoly);
    this.editZoneFlag = true;
    this.currentZone.isEdit = true;
    this.zones.forEach((inZone, z) => {
      this.zones[z].isEdit = false;
      if (inZone.id === zone.id) {
        this.zones[z].isEdit = true;
        this.currentZone.isEdit = false;
      }
    });
    this.zonePoly.forEach((innerZone, zIndex) => {
      if (this.isOsm) {
        this.map.removeControl(innerZone);
        // this.map.eachLayer(layer => {
        //   if (innerZone._backEndData.data.id === zone.id && this.zonePoly[zIndex]._backEndData.leafletId === layer._leaflet_id) {
        //     this.map.addControl(innerZone);
        //     let element: HTMLElement = document.getElementsByClassName("leaflet-draw-edit-edit")[0] as HTMLElement;
        //     element.click();
        //   }
        // });
        if (innerZone._backEndData.data.id === zone.id) {
          this.map.addControl(innerZone);
          this._layer = innerZone._backEndData.osmLayer || this._layer;
          const element: HTMLElement = document.getElementsByClassName("leaflet-draw-edit-edit")[0] as HTMLElement;
          if (element) {
            element.click();
          }
        }
      // } else {
      //   this.zonePoly[zIndex].setEditable(false);
      //   if (innerZone._backEndData.data.id === zone.id) {
      //     this.zonePoly[zIndex].setEditable(true);
      //   }
      } else if (innerZone?.setEditable) {
        this.zonePoly[zIndex].setEditable(false);
        if (innerZone._backEndData.data.id === zone.id) {
          this.zonePoly[zIndex].setEditable(true);
          this.bindGooglePolygonPath(this.zonePoly[zIndex]);
        }
      }
    });
  }

  saveZone(zone) {
    // if (this.editZoneFlag) {
    //   this.ngxLoader.start();
    //   const zoneboundary = this.convertPolyArrayToString(this.editzonebounds);
    //   this.apiService.doPutRequestWithResponse(ApiConstants.zone + zone.id + '&zonepoly=' + zoneboundary + '&zoneName=' + zone.name, '', success => {
    //     if (success.status == 200) {
    //       this.ngxLoader.stop();
    //       this.editZoneFlag = false;
    //       this.zonebounds = [];
    //       this.notifyService.showSuccess("Zone saved successfully.", null);
    //       this.getTripZones();
    //       this.removeEditControlOSM();
    //     }
    //   }, error => {
    //     this.ngxLoader.stop();
    //     this.notifyService.showError("Error, Failed to update!", null);
    //   });
    // }
    if (!this.editZoneFlag) {
      this.notifyService.showWarning("Please edit the zone before saving.", null);
      return;
    }
    const zoneboundary = this.getEditedZoneBoundary(zone);
    if (!zoneboundary) {
      this.notifyService.showError("Could not read the edited zone boundary.", null);
      return;
    }
    this.ngxLoader.start();
    this.apiService.doPutRequestWithResponse(
      ApiConstants.zone + zone.id + '&zonepoly=' + encodeURIComponent(zoneboundary) + '&zoneName=' + encodeURIComponent(zone.name),
      '',
      success => {
        if (success.status == 200) {
          this.ngxLoader.stop();
          this.editZoneFlag = false;
          this.zonebounds = [];
          this.editzonebounds = [];
          this.notifyService.showSuccess("Zone saved successfully.", null);
          this.getTripZones();
          this.removeEditControlOSM();
        } else {
          this.ngxLoader.stop();
          this.notifyService.showError("Error, Failed to update!", null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError("Error, Failed to update!", null);
      }
    );
  }

  private bindGooglePolygonPath(polygon: any): void {
    if (!polygon?.getPath) {
      return;
    }
    const syncPath = () => {
      this.zonebounds = polygon.getPath().getArray();
      if (this.editZoneFlag) {
        this.editzonebounds = polygon.getPath().getArray();
      }
    };
    syncPath();
    google.maps.event.addListener(polygon.getPath(), "set_at", syncPath);
    google.maps.event.addListener(polygon.getPath(), "insert_at", syncPath);
    google.maps.event.addListener(polygon.getPath(), "remove_at", syncPath);
  }

  private getEditedZoneBoundary(zone: any): string {
    const poly = (this.zonePoly || []).find(item => item?._backEndData?.data?.id === zone?.id);
    if (!this.isOsm && poly?.getPath) {
      return this.convertPolyArrayToString(poly.getPath().getArray());
    }
    if (this.isOsm) {
      const osmPoints = this.getOsmEditedLatLngs(poly);
      if (osmPoints.length) {
        return this.convertPolyArrayToString(osmPoints);
      }
    }
    return this.convertPolyArrayToString(this.editzonebounds);
  }

  private getOsmEditedLatLngs(poly: any): any[] {
    const candidates = [
      this._layer,
      poly?._backEndData?.osmLayer
    ];
    for (const layer of candidates) {
      const points = this.flattenOsmLatLngs(layer);
      if (points.length) {
        return points;
      }
    }
    if (!poly?._backEndData?.leafletId || !this.map?.eachLayer) {
      return [];
    }
    let points = [];
    this.map.eachLayer(layer => {
      if (layer._leaflet_id !== poly._backEndData.leafletId) {
        return;
      }
      const groupPoints = this.flattenOsmLatLngs(layer);
      if (groupPoints.length) {
        points = groupPoints;
      }
      if (typeof layer.eachLayer === 'function') {
        layer.eachLayer(child => {
          const childPoints = this.flattenOsmLatLngs(child);
          if (childPoints.length) {
            points = childPoints;
          }
        });
      }
    });
    return points;
  }

  private flattenOsmLatLngs(layer: any): any[] {
    if (!layer) {
      return [];
    }
    const nested = layer.editing?.latlngs || layer.getLatLngs?.() || layer._latlngs;
    let ring: any = nested;
    while (Array.isArray(ring) && ring.length && Array.isArray(ring[0])) {
      ring = ring[0];
    }
    if (!Array.isArray(ring)) {
      return [];
    }
    return ring.filter(point => this.toLatLngPoint(point));
  }

  private parseZonePoly(zonepoly: any): { lat: number; lng: number }[] {
    if (!zonepoly) {
      return [];
    }
    let raw = String(zonepoly).trim();
    try {
      raw = decodeURIComponent(raw);
    } catch { }
    const points = [];
    const pairRe = /\(\s*([+-]?\d*\.?\d+)\s*,\s*([+-]?\d*\.?\d+)\s*\)/g;
    let match;
    while ((match = pairRe.exec(raw))) {
      const lat = parseFloat(match[1]);
      const lng = parseFloat(match[2]);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        points.push({ lat, lng });
      }
    }
    if (points.length) {
      return points;
    }
    String(raw).split("),(").forEach(element => {
      let value = element;
      if (value.includes("(")) {
        value = value.split("(")[1];
      }
      if (value.includes(")")) {
        value = value.split(")")[0];
      }
      const parts = value.split(",");
      const lat = parseFloat(parts[0]);
      const lng = parseFloat(parts[1]);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        points.push({ lat, lng });
      }
    });
    return points;
  }

  convertPolyArrayToString(polyarray) {
    // let polyString = "";
    // polyarray.forEach(obj => {
    //   if (this.isOsm) {
    //     polyString += ",(" + obj.lat + "," + obj.lng + ")";
    //   } else {
    //     polyString += ",(" + obj.lat() + "," + obj.lng() + ")";
    //   }
    // });
    // polyString = polyString.replace(",", "");
    // return polyString;
    if (typeof polyarray === 'string') {
      return polyarray.replace(/^,/, '');
    }
    if (!Array.isArray(polyarray) || !polyarray.length) {
      return '';
    }
    if (polyarray.length === 1 && typeof polyarray[0] === 'string') {
      return polyarray[0];
    }
    const parts = [];
    polyarray.forEach(obj => {
      const point = this.toLatLngPoint(obj);
      if (point) {
        parts.push('(' + point.lat + ',' + point.lng + ')');
      }
    });
    return parts.join(',');
  }

  private toLatLngPoint(obj: any): { lat: number; lng: number } | null {
    if (obj == null) {
      return null;
    }
    if (typeof obj === 'string') {
      return null;
    }
    const lat = typeof obj.lat === 'function' ? obj.lat() : (obj.lat ?? obj[0]);
    const lng = typeof obj.lng === 'function' ? obj.lng() : (obj.lng ?? obj[1]);
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) {
      return null;
    }
    return { lat: latNum, lng: lngNum };
  }

}
